export default __webpack_public_path__ + "static/ransomware_logo-0f06b577c4ed06268f351e05b3226625.jpg";